import Component from "@glimmer/component";
import { get } from "@ember/helper";
import { isEmpty } from "@ember/utils";
import CustomFieldConfirm from "./custom/confirm";
import CustomFieldDropdown from "./custom/dropdown";
import CustomFieldMultiselect from "./custom/multi-select";
import CustomFieldText from "./custom/text";

const COMPONENTS = {
  confirm: CustomFieldConfirm,
  dropdown: CustomFieldDropdown,
  multiselect: CustomFieldMultiselect,
  text: CustomFieldText,
};

let nameCleanerRegex;

export default class FormFieldCustom extends Component {
  get classNames() {
    const baseClasses = [
      "custom-field",
      `custom-field--${this.args.field.type}`,
    ];
    const fieldName = this.args.field.name;

    if (fieldName) {
      const fieldClassName = fieldName
        .replace(/\s+/g, "-")
        .replace(nameCleanerRegex, "")
        .toLowerCase();

      if (!isEmpty(fieldClassName)) {
        return [...baseClasses, `custom-field__${fieldClassName}`];
      }
    }

    return baseClasses;
  }

  get component() {
    return COMPONENTS[this.args.field.type];
  }

  <template>
    <this.component
      class={{this.classNames}}
      ...attributes
      @field={{@field}}
      @buffer={{@buffer}}
      @value={{mut (get @buffer @field.name)}}
      @validation={{@validation}}
      @hidePlaceholder={{true}}
    />
  </template>
}

// regex from user-field/base.js
// It is being defined at the bottom of the file using a variable defined with let
// because defining it before the template tag is breaking both prettier and eslint parsers
nameCleanerRegex = /[!"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g;
